/**
 * Path of E10. Home links to it (`features/home/links.ts`, M1 AC13); a test keeps both equal.
 */
export const EMERGENCY_STOP_ROUTE = '/emergency-stop';
